// extracted by mini-css-extract-plugin
export default {"header":"client-referral-offboarding-module__header--eZz","body":"client-referral-offboarding-module__body--rU0","container":"client-referral-offboarding-module__container--GtK"};